var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9827 4.15936L10.8412 1.0171C10.7367 0.912603 10.6127 0.829713 10.4762 0.77316C10.3397 0.716607 10.1933 0.6875 10.0456 0.6875C9.89783 0.6875 9.75152 0.716607 9.61501 0.77316C9.47851 0.829713 9.35448 0.912603 9.25001 1.0171L0.579771 9.68803C0.474851 9.79212 0.391667 9.91603 0.335055 10.0525C0.278443 10.1891 0.249534 10.3355 0.250006 10.4833V13.6255C0.250006 13.9239 0.368532 14.21 0.579511 14.421C0.790489 14.632 1.07664 14.7505 1.37501 14.7505H4.51727C4.66506 14.751 4.81147 14.7221 4.94799 14.6655C5.08451 14.6089 5.20842 14.5257 5.31251 14.4208L13.9827 5.75053C14.0872 5.64606 14.1701 5.52203 14.2267 5.38553C14.2832 5.24902 14.3123 5.10271 14.3123 4.95495C14.3123 4.80719 14.2832 4.66088 14.2267 4.52437C14.1701 4.38786 14.0872 4.26383 13.9827 4.15936ZM4.51727 13.6255H1.37501V10.4833L7.56251 4.29577L10.7048 7.43803L4.51727 13.6255ZM11.5 6.6421L8.35774 3.50053L10.0452 1.81303L13.1875 4.9546L11.5 6.6421Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEdit);
export default __webpack_public_path__ + "static/media/whiteEdit.fcbd5bb7125c86c50faee05640752a8c.svg";
export { ForwardRef as ReactComponent };